import { connect } from 'react-redux';
// import PropTypes from 'prop-types';

import GraphDisplay from '../components/GraphDisplay';

const mapStateToProps = (state, ownProps) => {
	return {
		xData: state.graph.xData,
		xMax: state.graph.xMax,
		xMin: state.graph.xMin,
		xLabel: state.graph.xLabel,
		
		yData: state.graph.yData,
		yMax: state.graph.yMax,
		yMin: state.graph.yMin,
		yLabel: state.graph.yLabel,

		zData: state.graph.zData,
		zMax: state.graph.zMax,
		zMin: state.graph.zMin,
		zLabel: state.graph.zLabel,

		loading: state.graph.loading,
	};
};

const mapDispatchToProps = dispatch => {
    return {dispatch};
};

const ConnectedGraphDisplay = connect(
    mapStateToProps,
    mapDispatchToProps
)(GraphDisplay);

// ConnectedGraphDisplay.propTypes = {
// }

export default ConnectedGraphDisplay;



// WEBPACK FOOTER //
// ./src/containers/ConnectedGraphDisplay.js